import { render, staticRenderFns } from "./ItemEmbedCode.vue?vue&type=template&id=5ffd884f&"
import script from "./ItemEmbedCode.vue?vue&type=script&lang=js&"
export * from "./ItemEmbedCode.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ItemEmbedCode.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "7e90dd90"
  
)

export default component.exports